import backgroundPic from '../../../Pics/Landscapes/jpeg/clouds-cloudy-conifers-247478.jpg';

export const titleCardData = {
        titleText: 'Metaphysical Services for Personal Wellbeing',
        subText: 'THE COLLECTIVE THAT SUPPORTS YOUR ABUNDANT LIFE',
        backgroundimage: backgroundPic,
        styleId: 'homepage-titlecard'
}
